export default __webpack_public_path__ + "static/media/LandingPageVideoPortrait.ced9e71a.jpg";